const $=window.$;

    export const showRecapPre=()=>{
        let curent=$('#txthidden').val();
        let previous=curent-1;
        let tot=$('#txttothid').val();
        let tocheck=tot+1;

        for(let i=0;i<tot;i++)
        {
          $('#Hire'+i).css('display','none');
        }
        
        if(previous>tocheck)
        {
          $('#NextBut').css('display','block');
          $('#PreviousBut').css('display','block');
        }
        else
        { 
          $('#NextBut').css('display','block');
          $('#PreviousBut').css('display','block');
        }
        if(previous==0)
          $('#PreviousBut').css('display','none');
          $('#Hire'+previous).css('display','block');
          $('#txthidden').val(previous);
        
      }
      
     export const showRecapNext=()=>{
        let curent=$('#txthidden').val();
        let next=parseInt(curent)+1;
        
        let tot=$('#txttothid').val();
        let tocheck=tot-1;
        for(let i=0;i<tot;i++)
        {
          $('#Hire'+i).css('display','none');
        }
        if(next<tocheck)
        {
          $('#NextBut').css('display','block');
          $('#PreviousBut').css('display','block');
        }
        else
        { 
          $('#NextBut').css('display','none');
          $('#PreviousBut').css('display','block');
        }
        
        $('#Hire'+next).css('display','block');
        $('#txthidden').val(next);
        
      }

      export const showRecapPreDLR=()=>{
        let curent=$('#DLRtxthidden').val();
        let previous=curent-1;
        let tot=$('#DLRtxttothid').val();
        let tocheck=tot+1;
        for(let i=0;i<tot;i++) {
          $('#DLRHire'+i).css('display','none');
        }
        if(previous>tocheck) {
          $('#DLRNextBut').css('display','block');
          $('#DLRPreviousBut').css('display','block');
        } else {  
          $('#DLRNextBut').css('display','block');
          $('#DLRPreviousBut').css('display','block');
        }

        if(previous==0)
          $('#DLRPreviousBut').css('display','none');
          $('#DLRHire'+previous).css('display','block');
          $('#DLRtxthidden').val(previous);
        }

      export const showRecapNextDLR=()=>{
        let curent=$('#DLRtxthidden').val();
        let next=parseInt(curent)+1;
        let tot=$('#DLRtxttothid').val();
        let tocheck=tot-1;
        for(let i=0;i<tot;i++) {
          $('#DLRHire'+i).css('display','none');
        }
        if(next<tocheck) {
          $('#DLRNextBut').css('display','block');
          $('#DLRPreviousBut').css('display','block');
        } else {
          $('#DLRNextBut').css('display','none');
          $('#DLRPreviousBut').css('display','block');
        }
        $('#DLRHire'+next).css('display','block');
        $('#DLRtxthidden').val(next);
      }


     export const  showModuleLr=(x)=> {
        $('#ModuleHier'+x).css('display','block');
      }
      export const showModule=()=>{
        let currrentModule=$('#lstModuleSelect').val();
        let b=currrentModule.split("#");
        
        let Totalmodule=$('#TotalModuleValue').val();
        $(".allcss").css('display','none');
        
        $('#Mod1'+b[0]).css('display','block');
        $('#Mod'+b[0]).css('display','block');
        
        $('#ButtonShow'+b[0]).css('display','block');
        
        $('#LROOM'+b[1]).css('display','block');
        showModuleLr(b[1]);
      }
                  
      export const showRecapPreMod=(x)=>{
        let overll =$('#moduleLrIds'+x).val();
        let tot=$('#txtOverallCount'+x).val();
        let curCnt=$('#CurrentCount'+x).val();
        let toshow=parseInt(curCnt)-1;
        let toCheck=parseInt(toshow)-1
        let a=overll.split(",");
        $(".lrroomcss").css('display','none');
        
        $('#ModuleHier'+a[toshow]).css('display','block');

        if(tot>toshow)
        {
          $('#NextButModule'+x).css('display','block');
          $('#PreviousButModule'+x).css('display','block');
        }
        else
        { 
          $('#NextButModule'+x).css('display','block');
          $('#PreviousButModule'+x).css('display','block');
        }
        if(toshow==0)
        {
          $('#PreviousButModule'+x).css('display','none');
        }
        $('#CurrentCount'+x).val(toshow);
        
      }
     export const showRecapNextMod=(x)=>{
        let overll =$('#moduleLrIds'+x).val();
        let tot=$('#txtOverallCount'+x).val();
        let curCnt=$('#CurrentCount'+x).val();
        
        let toshow=parseInt(curCnt)+1;
        let toCheck=parseInt(toshow)+1;
        //let a=JSON.stringify(overll).split(",");
        let a=overll.split(",");
        
        $(".lrroomcss").css('display','none');
        
        $('#ModuleHier'+a[toshow]).css('display','block');
        //this.showModuleLr(a[toshow]);
        if(tot>toshow)
        {
          $('#NextButModule'+x).css('display','block');
          $('#PreviousButModule'+x).css('display','block');
        }
        else
        { 
          $('#NextButModule'+x).css('display','block');
          $('#PreviousButModule'+x).css('display','block');
        }
        if(tot==toCheck)
        {
          $('#NextButModule'+x).css('display','none');
        }
        $('#CurrentCount'+x).val(toshow);       
      }

      export const DLRModuleshowModuleLr=(x)=> {
        $('#DLRModuleModuleHier'+x).css('display','block');        
      }
      
     export const DLRModuleshowModule=()=> {

      let currrentModule = $('#DLRModulelstModuleSelect').val();
        let b = currrentModule.split("#");        
        let Totalmodule = $('#DLRModuleTotalModuleValue').val();
        //alert(b);
        $('.dlr_allcss').css('display','none');

        $('#DLRModuleMod1'+b[0]).css('display','block');
        $('#DLRModuleMod'+b[0]).css('display','block');
        $('#DLRModuleModuleHier'+b[1]).css('display','block');
        

        $('#DLRModuleButtonShow'+b[0]).css('display','block');
        
        DLRModuleshowModuleLr(b[1]);
      }               
      
      export const DLRModuleshowRecapPreMod=(x)=>{
        let overll = $('#DLRModuletxtOverallLearningRoom'+x).val();
        let tot = $('#DLRModuletxtOverallCount'+x).val();
        let curCnt = $('#DLRModuleCurrentCount'+x).val();
        let toshow=parseInt(curCnt)-1;
        let toCheck=parseInt(toshow)-1
        let a=overll.split(",");
        
        $(".dlrroomcss").css('display','none');

        $('#DLRModuleModuleHier'+a[toshow]).css('display','block');

        if(tot>toshow)
        {
          $('#DLRModuleNextButModule'+x).css('display','block');
          $('#DLRModulePreviousButModule'+x).css('display','block');
        }
        else
        { 
          $('#DLRModuleNextButModule'+x).css('display','block');
          $('#DLRModulePreviousButModule'+x).css('display','block');
        }
        if(toshow==0)
        {
          $('#DLRModulePreviousButModule'+x).css('display','none');
        }
        $('#DLRModuleCurrentCount'+x).val(toshow);
      }

      export const DLRModuleshowRecapNextMod=(x)=> {
        let overll = $('#DLRModuletxtOverallLearningRoom'+x).val();
        let tot    = $('#DLRModuletxtOverallCount'+x).val();
        let curCnt = $('#DLRModuleCurrentCount'+x).val();
        let toshow=parseInt(curCnt)+1;
        let toCheck=parseInt(toshow)+1
        let a=overll.split(",");

        $(".dlrroomcss").css('display','none');

        $('#DLRModuleModuleHier'+a[toshow]).css('display','block');
        
        if(tot>toshow)
        {
          $('#DLRModuleNextButModule'+x).css('display','block');
          $('#DLRModulePreviousButModule'+x).css('display','block');
        }
        else
        { 
          $('#DLRModuleNextButModule'+x).css('display','block');
          $('#DLRModulePreviousButModule'+x).css('display','block');
        }
        if(tot==toCheck)
        {
          $('#DLRModuleNextButModule'+x).css('display','none');
        }
        $('#DLRModuleCurrentCount'+x).val(toshow);
      }

     


// WEBPACK FOOTER //
// ./src/components/Prevnext.js